module.exports = __webpack_public_path__ + "static/media/style-2.007a2798.svg";